/**
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */

export const TOP_CATEGORIES_DEPTH_LIMIT = "11,15,-1,-1";

export const PRODUCT_LIST_FIELDS = "facetView";

export const KEYWORD_LIMIT = 4;
export const PRODUCT_SEARCH_LIMIT = 3;

export const PAGINATION_CONFIGS = {
  pageLimit: 20,
  pageDefaultOffset: 0, //The page offset to start with on pageload and filters
};
